/*
 * fn: getCardFirstName
 *
 * Gets just the first name for a card (for legendary cards)
 *
 */
export const getCardFirstName = (name: string) => name.split(',')[0] ?? name
